<template>
  <div class="layout-base--public">
    <v-app-bar app flat dark color="primary">
      <app-bar-home-link />

      <v-spacer />

      <v-btn text to="/login">
        Entrar
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-container fluid style="height: 100%;">
        <v-slide-x-transition mode="out-in">
          <slot />
        </v-slide-x-transition>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import AppBarHomeLink from './components/AppBarHomeLink.vue';

export default {
  name: 'LayoutBasePublic',

  components: {
    AppBarHomeLink,
  },
};
</script>
